import React from 'react'
import PropTypes from 'prop-types'

import colors from '../../../../../../_constants/colors'
import { Box } from '../../../../../../components/Box/Box'
import { Text } from '../../../../../../_components/Typography/Components/Text/Text'
import { Progress } from '../../../../../../components/Progress/Progress'
import { LoaderButton } from '../../../../../../_components/LoaderButton'
import { ButtonRow } from '../../../../../../_components/layout/ButtonRow'
import { H4 } from '../../../../../../_components/Typography/Components/Headings/H4'
import { RenderIf } from '../../../../../../components/helpers/RenderIf/RenderIf'
import DateFormatter from '../../../../../../_helpers/date-formatter'
import { UTCDateToSystemString } from '../../../../../../_helpers/dates'
import { sendSignatureRequestReminder } from '../../../../../../_services/v2/documents.service'
import { useNotifications } from '../../../../../../_reduxHooks/notifications.hook'

const SignerStatus = ({ signatureRequestId, signer }) => {
  const [isLoading, setIsLoading] = React.useState(false)
  const { showNotification } = useNotifications()

  const handleSendReminder = async () => {
    await sendSignatureRequestReminder(signatureRequestId, signer.id)
      .then(() => {
        setIsLoading(false)
        showNotification({
          type: `success`,
          message: 'Reminder sent successfully',
        })
      })
      .catch((error) => {
        setIsLoading(false)
        showNotification({
          type: `error`,
          message: error,
        })
      })
  }

  const signerRole = (role) => {
    if (role === 'Tenant') {
      return 'Lender'
    }
    return role
  }
  return (
    <Box borderStyle={'solid'} bwt={'1px'} pb={'10px'} pt={'10px'}>
      <Box alignItems={'center'} d={'flex'} justifyContent={'space-between'}>
        <Box>
          <Box alignItems={'flex-start'} d={'flex'}>
            <Text>{signer.name}</Text>
            <Box
              borderRadius={'10px'}
              boxBackgroundColor={colors.INNER_GREY_BOX}
              ml={'5px'}
              pb={'2px'}
              pl={'5px'}
              pr={'5px'}
              pt={'2px'}
              textColor={colors.DEFAULT_TEXT}
            >
              <Text fs={'12px'} fw={400}>
                {signerRole(signer.role)}
              </Text>
            </Box>
          </Box>
          <Text fs={'12px'}>{signer.email}</Text>
          <Text fs={'12px'} mt={'5px'} textColor={colors.TEXT_LIGHT}>
            Sent {new DateFormatter(UTCDateToSystemString(signer.created_at)).getTime('MM/DD/YYYY hh:mm A')}
          </Text>
          <RenderIf condition={signer.viewed_at}>
            <Text fs={'12px'} mt={'5px'} textColor={colors.TEXT_LIGHT}>
              Viewed {new DateFormatter(UTCDateToSystemString(signer.viewed_at)).getTime('MM/DD/YYYY hh:mm A')}
            </Text>
          </RenderIf>
          <RenderIf condition={signer.signed_at}>
            <Text fs={'12px'} mt={'5px'} textColor={colors.TEXT_LIGHT}>
              Signed {new DateFormatter(UTCDateToSystemString(signer.signed_at)).getTime('MM/DD/YYYY hh:mm A')}
            </Text>
          </RenderIf>
        </Box>

        <Box>
          <ButtonRow>
            <RenderIf condition={signer.state === 'awaiting_signature'}>
              <LoaderButton
                className={'compact'}
                isLoading={isLoading}
                onClick={handleSendReminder}
                text={'Resend Link'}
              />
            </RenderIf>
          </ButtonRow>
        </Box>
      </Box>
    </Box>
  )
}
export const SignatureDocumentStatus = ({ state, documentName, signers, id }) => {
  let progress = 15
  signers.forEach((signer) => {
    if (signer.state === 'signed') {
      progress += 85 / signers.length
    }
  })

  return (
    <Box>
      <Box alignItems={'center'} d={'flex'} mb={'10px'}>
        <H4 mr={'10px'}>{documentName}</H4>
        <RenderIf condition={state === 'completed'}>
          <Progress fillColor={colors.MATERIAL_GREEN} progress={'100%'} textStatus={'Complete'} width={'80px'} />
        </RenderIf>
        <RenderIf condition={state !== 'completed'}>
          <Progress
            fillColor={colors.MATERIAL_ORANGE}
            progress={`${progress}%`}
            textStatus={'In Progress'}
            width={'80px'}
          />
        </RenderIf>
      </Box>
      <Box alignItems={'center'} d={'flex'} mb={'10px'}>
        <Text fw={700} mr={'10px'}>
          Signers ({signers.length}):
        </Text>
      </Box>

      {signers.map((signer, index) => {
        return <SignerStatus key={index} signatureRequestId={id} signer={signer} />
      })}
    </Box>
  )
}

SignatureDocumentStatus.propTypes = {
  documentName: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([false])]),
  eventString: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([false])]),
}

SignatureDocumentStatus.defaultProps = {
  documentName: '',
  eventString: '',
}
